<template>
    <div>
        <div class="smallContent" id="schedule">

            <!--
        <div class="seperator">Schedule</div>
        <div class="groupElement">
            <div class="item">
                Schedule
            </div>
        </div>
        -->



            <div v-if="
                (!store.showSchedule || store.liveList.length == 0) &&
                !store.live
            ">
                <!-- <p>Broadcasting live {{ getUpcomingItem }}.</p> -->
                <p id="announcementText">
                    We are back on air {{ getUpcomingItem }}. In the meantime,
                    become a Montez Press Radio Supporter and get instant access
                    to our entire, evergrowing archive.
                </p>
            </div>

            <div v-else>
                <div id="scheduleHeader">
                    <div id="filters">
                        <div @click="filter = 'all'" :class="{ active: filter == 'all' }">All</div>
                        <div @click="filter = 'live'" :class="{ active: filter == 'live' }">Live</div>
                        <div @click="filter = 'prerecorded'" :class="{ active: filter == 'prerecorded' }">Prerecorded
                        </div>
                    </div>

                    <div id="displaySelector">

                        <img id="grid" @click="displayAsList = false" :src="!displayAsList || gridHover
                            ? 'static/new_icons/grid_active.svg'
                            : 'static/new_icons/grid.svg'
                            " @mouseover="gridHover = true" @mouseout="gridHover = false" />
                        <img id="list" @click="displayAsList = true" :src="displayAsList || listHover
                            ? 'static/new_icons/list_active.svg'
                            : 'static/new_icons/list.svg'
                            " @mouseover="listHover = true" @mouseout="listHover = false" />
                    </div>
                </div>

                <div v-if="displayAsList == false">
                    <div v-for="monthObject in monthList" class="elementContainer">
                        <div>
                            <div>{{ monthObject.month.setLocale("en-US").monthLong }}</div>
                            <div class="weekdayGrid">
                                <div class="weekdays">M</div>
                                <div class="weekdays">T</div>
                                <div class="weekdays">W</div>
                                <div class="weekdays">T</div>
                                <div class="weekdays">F</div>
                                <div class="weekdays">S</div>
                                <div class="weekdays">S</div>
                            </div>
                            <div class="calendar">
                                <div v-for="day in monthObject.days" class="days"
                                    @click="getItemsOfDay(day) && day.month == monthObject.month.month ? handleCalendarClick(monthObject, day) : null"
                                    :class="{ calendarGrey: day.month != monthObject.month.month, marked: getItemsOfDay(day) && day.month == monthObject.month.month, active: monthObject.activeDays.includes(day.toISO()) }">
                                    {{ day.day }}
                                </div>
                            </div>
                        </div>
                        <Element v-for="item in getFilteredOfMonth(monthObject)" :live="store.live" :first="false"
                            :key="item.id" :item="item" :isArchive="false" :onArchive="false" :onSchedule="true"
                            :isPick="false">
                        </Element>
                    </div>
                </div>


                <!-- <div v-if="store.showSchedule || store.live" class="groupElement" :key="date" -->
                <!--     v-for="(list, date) in store.groupedLiveList"> -->
                <div v-else class="groupElement" :key="date" v-for="(list, date) in filtered">
                    <div class="groupItem">{{ getFormattedDate(date) }}</div>
                    <router-link v-for="item in list" class="item" :key="item.pk" :class="[
                        item.category,
                        { active: store.live && item.pk == store.liveTrack.pk },
                    ]" :to="{ name: 'detail', params: { id: item.pk } }">
                        <p class="time">
                            <span v-html="getFormattedTime(item)"> </span>
                            <span class="live" v-if="store.live && item.pk == store.liveTrack.pk">LIVE NOW</span>
                        </p>
                        <p>
                            {{ item.artist
                            }}<span v-if="item.artist && item.title">:</span>
                            {{ item.title }}
                        </p>
                        <p v-if="item.show_location_live" class="location">
                            Live at {{ item.venue }}, {{ item.city }}
                        </p>
                    </router-link>
                </div>
            </div>



        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { DateTime, Interval } from "luxon";
import { store } from "../store";
import Footer from "./Footer.vue";
import Element from "./Element";

export default {
    name: "Schedule",
    components: {
        Footer,
        Element,
    },
    data() {
        return {
            store: store,
            activeDay: null,
            displayAsList: false,
            filter: 'all',
            gridHover: false,
            listHover: false,
            filtered: {},
            monthList: [],
        };
    },
    watch: {
        filter: {
            handler(newFilter) {
                this.applyFilter()
            },
            immediate: true,
        },
        'store.groupedLiveList': {
            handler(newFilter) {
                if (!this.monthList.length) {
                    this.applyFilter()
                }
            },
            immediate: true,
            once: true,
        }

    },
    computed: {
        // getFiltered: function () {
        //     if (this.filter == 'all') {
        //         return this.store.groupedLiveList
        //     } else if (this.filter == 'live') {
        //         let newObject = {}
        //         for (let [key, values] of Object.entries(this.store.groupedLiveList)) {
        //             let newValues = values.filter(i => i.show_location_live == true)
        //             if (newValues.length) {
        //                 newObject[key] = newValues
        //             }
        //         }
        //         return newObject
        //     } else {
        //         let newObject = {}
        //         for (let [key, values] of Object.entries(this.store.groupedLiveList)) {
        //             let newValues = values.filter(i => i.show_location_live == false)
        //             if (newValues.length) {
        //                 newObject[key] = newValues
        //             }
        //         }
        //         return newObject

        //     }

        // },
        getUpcomingItem: function () {
            if (this.store.liveList.length > 0) {
                //return 'at ' + this.list[0].start_time;
                return (
                    "on " +
                    DateTime.fromISO(this.store.liveList[0].start_time, {
                        zone: "utc",
                    })
                        .toLocal()
                        .toFormat("MMMM d")
                );
            } else {
                return "again soon";
            }
        },
        // getMonths: function () {
        //     let dayStrings = Object.keys(this.getFiltered)
        //     if (dayStrings.length > 0) {
        //         let dayList = []
        //         dayStrings.forEach(dayString => {
        //             let day = new DateTime.fromISO(dayString)
        //             let monthStart = day.startOf('month')
        //             if (!dayList.some(x => x.ts == monthStart.ts)) {
        //                 dayList.push(monthStart)
        //             }
        //         })
        //         let monthList = []
        //         dayList.forEach(month => {
        //             const intervals = Interval.fromDateTimes(
        //                 month,
        //                 month.endOf('month').endOf("day")
        //             )
        //                 .splitBy({ day: 1 })
        //                 .map(d => d.start);

        //             // while (intervals[0].)
        //             let firstDay = intervals[0]
        //             for (let i = 1; i < firstDay.weekday; i++) {
        //                 let newDay = firstDay.minus({ days: i })
        //                 intervals.unshift(newDay)
        //             }
        //             let lastDay = intervals[intervals.length - 1]
        //             for (let i = 1; i < (8 - lastDay.weekday); i++) {
        //                 let newDay = lastDay.plus({ days: i })
        //                 intervals.push(newDay)
        //             }
        //             monthList.push({
        //                 month: month,
        //                 days: intervals,
        //                 activeDays: [],
        //             })
        //         })
        //         return monthList
        //     }

        // }
    },
    methods: {
        applyFilter() {
            if (this.filter == 'all') {
                this.filtered = this.store.groupedLiveList
            } else if (this.filter == 'live') {
                let newObject = {}
                for (let [key, values] of Object.entries(this.store.groupedLiveList)) {
                    let newValues = values.filter(i => i.show_location_live == true)
                    if (newValues.length) {
                        newObject[key] = newValues
                    }
                }
                this.filtered = newObject
            } else {
                let newObject = {}
                for (let [key, values] of Object.entries(this.store.groupedLiveList)) {
                    let newValues = values.filter(i => i.show_location_live == false)
                    if (newValues.length) {
                        newObject[key] = newValues
                    }
                }
                this.filtered = newObject
            }
            this.monthList = this.setMonths()


        },
        setMonths() {
            let dayStrings = Object.keys(this.filtered)
            if (dayStrings.length > 0) {
                let dayList = []
                dayStrings.forEach(dayString => {
                    let day = new DateTime.fromISO(dayString)
                    let monthStart = day.startOf('month')
                    if (!dayList.some(x => x.ts == monthStart.ts)) {
                        dayList.push(monthStart)
                    }
                })
                let monthList = []
                dayList.forEach(month => {
                    const intervals = Interval.fromDateTimes(
                        month,
                        month.endOf('month').endOf("day")
                    )
                        .splitBy({ day: 1 })
                        .map(d => d.start);

                    // while (intervals[0].)
                    let firstDay = intervals[0]
                    for (let i = 1; i < firstDay.weekday; i++) {
                        let newDay = firstDay.minus({ days: i })
                        intervals.unshift(newDay)
                    }
                    let lastDay = intervals[intervals.length - 1]
                    for (let i = 1; i < (15 - lastDay.weekday); i++) {
                        let newDay = lastDay.plus({ days: i })
                        intervals.push(newDay)
                    }
                    monthList.push({
                        month: month,
                        days: intervals,
                        activeDays: [],
                    })
                })
                return monthList
            } else {
                return []
            }

        },

        getFilteredOfMonth(monthObject) {
            let filtered_items = []
            for (let [day, items] of Object.entries(this.filtered)) {
                let luxon_day = new DateTime.fromISO(day)
                if (luxon_day.month == monthObject.month.month) {
                    if (!monthObject.activeDays.length) {
                        filtered_items.push(...items)
                    } else if (monthObject.activeDays.includes(luxon_day.toISO())) {
                        filtered_items.push(...items)
                    }
                }
            }
            return filtered_items

        },
        handleCalendarClick(monthObject, day) {
            if (monthObject.activeDays.includes(day.toISO())) {
                monthObject.activeDays = monthObject.activeDays.filter(d => d != day.toISO())
            } else {
                monthObject.activeDays.push(day.toISO())
            }
            // if (this.activeDay == day.toISO()) {
            //     this.activeDay = null
            // } else {
            //     this.activeDay = day.toISO()
            // }
        },
        getItemsOfDay(day) {
            return Object.keys(this.filtered).some(i => i == day.toISODate())
        },
        getFormattedTime(item) {
            let aware = DateTime.fromISO(item.start_time, {
                zone: item.timezone,
            }).setLocale("en-US");
            // console.log(aware.zoneName);
            let local = aware.setZone("local");

            if (aware.offset != local.offset) {
                return `${local.toFormat("hh:mm")}&thinsp;${local.toFormat(
                    "a"
                )}&ensp;(${aware.toFormat("hh:mm")}&thinsp;${aware.toFormat(
                    "a"
                )}&ensp;${item.city})`;
            } else {
                return `${aware.toFormat("hh:mm")}&thinsp;${aware.toFormat(
                    "a"
                )}`;
            }
        },
        getFormattedDate: function (myDate) {
            var formatted = DateTime.fromISO(myDate)
                .setLocale("en-US")
                .toRelativeCalendar();
            if (formatted == "today") {
                return "Today";
            } else {
                let date = DateTime.fromISO(myDate)
                    .setLocale("en-US")
                    .toLocaleString(DateTime.DATE_HUGE);
                return date;
            }
        },
    },
};
</script>

<style scoped>
.seperator {
    padding: 0.7rem 1rem 0.8rem;
    border-bottom: 1px solid black;
    width: calc(100% - 2rem);
}

#schedule {
    /*margin: 0.7rem 0rem 1rem;*/
    /* margin-bottom: -1rem; */
}

.groupElement {}

.groupElement>div:first-of-type {}

.groupElement:last-child {
    margin-bottom: 2rem;
}

.groupItem {
    border-bottom: 1px solid black;
    padding: 1.6rem 1rem;
}

.groupElement:first-child>.groupItem {
    padding-top: 0.7rem;
}

.item {
    padding: 0.7rem 1rem 1.1rem;
    border-bottom: 1px solid black;
    display: block;
    display: flex;
    flex-direction: column;
}

.item:last-child {}

#otherItem {
    padding: 0;
    margin-top: -0.8rem;
    display: block;
}

.item p,
.otherItem p {
    margin: 0;
}

.item span.live {
    margin-left: 1rem;
    font-family: "Montez Small";
    font-size: 1rem;
    animation: blink-animation 2s steps(2, start) infinite;
    -webkit-animation: blink-animation 2s steps(2, start) infinite;
}

@keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

@-webkit-keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

a.LI:hover,
a.LI.active {
    background-color: #8dd9fc;
}

a.IS:hover,
a.IS.active {
    background-color: #f6b2c6;
}

a.IR:hover,
a.IR.active {
    background-color: #f6b2c6;
}

a.RE:hover,
a.RE.active {
    background-color: #9fe1a7;
}

a.NY:hover,
a.NY.active {
    background-color: #fcfac4;
}

.time {
    /* font-variant-numeric: tabular-nums; */
    /* font-feature-settings: "tnum" on; */
}

#announcementText {
    width: 100%;
    padding: 12px 15px;
    background-color: #f9f57d;
    box-sizing: border-box;
    margin: 0;
    text-align: center;
}

.location {
    font-family: "Montez Small";
    font-size: 12px;
    border: 1px solid black;
    border-radius: 1rem;
    display: inline;
    padding: 0px 0.6rem 2px;
    align-self: flex-start;
    margin-top: 0.8rem !important;
}

.days.calendarGrey {
    color: grey;
    cursor: default;
}

.weekdays {
    /* border-bottom: 1px solid black; */
    /* padding: 12px 21px; */
    /* margin-left: -1px; */
    /* padding: 12px; */
}

.days {
    padding: 5px;
    min-width: 20px;
    text-align: center;
    border-radius: 50%;
    cursor: default;
}

.days.marked {
    border: 1px solid black;
    font-family: "Montez Small";
    font-size: 12px;
    cursor: pointer;
}

.days.marked:hover {
    color: white;
    background-color: black;
}

.days.active {
    color: white;
    background-color: black;
    font-family: "Montez Small";
    font-size: 12px;
    cursor: pointer;
}

.calendar {
    width: calc(100% - 20px);
    height: auto;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    justify-items: center;
    align-items: center;
    border-bottom: 1px solid black;
    gap: 10px;
    padding: 10px;
}

@media only screen and (min-width: 738px) {
    .calendar {
        min-height: calc(100% - 16.6rem);
    }
}

.weekdayGrid {
    margin: 1rem 0 0;
    width: calc(100% - 20px);
    padding: 10px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    justify-items: center;
    align-items: center;
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    gap: 10px;

}

@media only screen and (min-width: 738px) {
    .weekdayGrid {
        /* height: 5rem; */
    }
}

.calendarContainer {
    margin: 2rem 0;
}

#scheduleHeader {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1rem 0.8rem;
}

#filters {
    display: flex;
    gap: 0.5rem;
}

#displaySelector {
    display: flex;
    gap: 1rem;
}

#displaySelector>img {
    width: 2rem;
    cursor: pointer;
}

#filters>div {
    border-radius: 2rem;
    border: 1px solid black;
    padding: 0rem 0.6rem;
    cursor: pointer;
    font-family: "Montez Small";
    font-size: 12px;
}

#filters>div.active,
#filters>div:hover {
    color: white;
    background-color: black;
}
</style>
